import { Attach20Regular, Sparkle20Regular, TextEditStyle20Regular } from '@/components/Icon'
import { IconButton } from '@mui/material'
import Tooltip from '@/components/Tooltip'
import { MAX_MESSAGE_ATTACHMENTS } from './aiAskBarLayoutConstants'
import styles from './index.module.scss'

export default function AiAskBarEmailReplyToolbarPrimary({ attachments, handleOpenFilePicker }) {
  return (
    <>
      <Tooltip text="Attach" placement="top">
        <IconButton
          type="button"
          className={styles.circleAction}
          onClick={handleOpenFilePicker}
          aria-label="Attach"
          disabled={attachments.length >= MAX_MESSAGE_ATTACHMENTS}
        >
          <Attach20Regular className={styles.circleIcon} aria-hidden />
        </IconButton>
      </Tooltip>
      <Tooltip text="Help me write" placement="top">
        <IconButton type="button" className={styles.circleAction} aria-label="Help me write">
          <Sparkle20Regular className={styles.circleIcon} aria-hidden />
        </IconButton>
      </Tooltip>
      <Tooltip text="Formatting" placement="top">
        <IconButton type="button" className={styles.circleAction} aria-label="Formatting">
          <TextEditStyle20Regular className={styles.circleIcon} aria-hidden />
        </IconButton>
      </Tooltip>
    </>
  )
}
